import { getToken } from "src/helpers";

const X_APP_HEADER_VALUE = "eagle-external";

const defaultHeaders = {
  "X-APP": X_APP_HEADER_VALUE
};

export const getDefaultHeaders = (): Record<string, string> =>
  (token =>
    token
      ? {
          ...defaultHeaders,
          Authorization: `Bearer ${token}`
        }
      : defaultHeaders)(getToken());
